import { getObject } from 'Domain/Mesh/Handler/ErrorHandler'

/*****************************************************************
 * Error Handler
 * ***************************************************************/

/**
 * Retrieve error panel
 * @param {number} errorCode
 * @returns object
 */
export const getErrorObject = errorCode => getObject( errorCode )
.then( mesh => {
    mesh.rotation.set( 1.6, 0, 0 )
    mesh.position.set( 0, -1, 1 )
    return mesh
} )